import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export const copyUrlButtonDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
    focus: () => base.getNative().then((el) => el.focus()),
  };
};

export type CopyUrlButtonDriver = ReturnType<typeof copyUrlButtonDriverFactory>;
